import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import { asArray } from 'ol/color';

export class PolygonStyle {

  public getPolygonStyleStyle(color: string, stroke: number, opacity: number): Style {

    const c = asArray(color).slice(); // clone so we don't mutate original
    c[3] = opacity; // set alpha channel

    return new Style({
      stroke: new Stroke({
        color,
        width: stroke
      }),
      fill: new Fill({
        color: c
      })
    });
  }
}
